import styled, { keyframes } from 'styled-components';

const animation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const StyledLoader = styled.div`
  animation: ${animation} 600ms linear infinite;
  width: ${(p) => p.theme.space[4]};
  height: ${(p) => p.theme.space[4]};
  margin: ${(p) => p.theme.space[0]} auto;
  border: 2px solid ${(p) => p.theme.alias.shadow};
  border-top-color: ${(p) => p.theme.alias.subtle};
  border-radius: ${(p) => p.theme.radii.pill};
`;
